import dayjs from 'dayjs';
import React from 'react';

export interface HdDateFormatProps {
  value: Date | dayjs.Dayjs | string | number;
  format?: string;
  isUTC?: boolean;
}

export function HdDateFormat({ value, format = 'll', isUTC }: HdDateFormatProps) {
  if (!value) {
    return null;
  }

  if (isUTC) {
    return <React.Fragment>{dayjs(value).utc().format(format)}</React.Fragment>;
  }

  return <React.Fragment>{dayjs(value).format(format)}</React.Fragment>;
}
